import styled from "styled-components";

export const Container = styled.div`
  height: 686px;
  background: #f0f2f5;
  position: relative;
  max-width: 1280px;
  width: auto;
  align-items: center;
  justify-content: space-between;
  margin: 12px auto;
  display: flex;
  @media screen and (max-width: 991px) {
    width: 100%;
    flex-direction: column;
  }
  @media screen and (max-width: 425px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const InfoSection = styled.div`
  align-items: center;
  width: 50%;
  padding: 40px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 991px) {
    width 100%
    
  }
  @media screen and (max-width: 425px) {
    width 100%
  }
`;
export const InfoSectionFig = styled.figure`
  width: 100%;
  margin: 0 0 1em;
  text-align: center;
`;

export const InfoSectionImg = styled.img`
  background-image: url(${(props) => props.src});
  background-size: cover;
  width: 328px;
  height: auto;
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const TitleHead = styled.h2`
  text-align: center;
`;

export const TitleInfo = styled.p`
  text-align: center;
`;

export const ActivitySection = styled.div`
  background: #ffffff;
  display: flex;
  height: 100%;
  width: 50%;
  padding:50px;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 991px) {
    width 100%
    
  }
  @media screen and (max-width: 425px) {
    width 100%
  }
`;

export const ActvtySecWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 92%;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
`;

export const ActvtySecTitle = styled.h1`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  align-items: center;
  text-align: center;
  color: #262626;
`;

export const AlertMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 16px;
  position: relative;
  left: 0%;
  right: 0%;
  top: -1%;
  bottom: 0%;
  background: #fff1f0;
  border: 1px solid #ffa39e;
  box-sizing: border-box;
  border-radius: 2px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 10px 0px;
`;

export const AlertMessage = styled.div`
  position: static;
  width: 368px;
  height: 22px;
  left: 16px;
  top: 9px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 8px 0px;
`;

export const AlertMessageContent = styled.p`
  position: absolute;
  left: 15px;
  right: 24px;
  top: 6px;
  bottom: 0px;
  font-family: SF Pro Display;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
`;

export const IconContainer = styled.span`
  position: absolute;
  width: 16px;
  height: 22px;
  right: 13px;
  top: 7px;
`;

export const LoginNow = styled.p`
  left: -11rem;
  position: relative;
  bottom: -1rem;
`;
export const HeadIcons = styled.div`
  font-size: large;
  color: white;
  position: absolute;
  color: white;
  top: 1rem;
  display: inline;
  right: 4rem;
`;
export const DBCompHeading = styled.h1`
  font-size: x-large;
  float: left;
`;
